<template>
  <CRow>
    <CCol col="12" v-if="found">
      <CCard>
        <loader v-show="loading" />
        <CCardHeader>
          <CIcon name="cil-lan" /> &nbsp; <strong>Outlet Transaction</strong>
          <div class="card-header-actions">
            <CLink href="#" @click="doBack">
              <CIcon name="cil-arrow-circle-left" size="lg" />
            </CLink>
          </div>
        </CCardHeader>
        <CCardBody>
          <div class="tab-content">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Status</th>
                  <th>No Struk</th>
                  <th>Waktu</th>
                  <th>Metode Pembayaran</th>
                  <th>Kasir</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v, k) in data.data" :key="k">
                  <td>
                    <table-number
                      :size="data.paginate.size"
                      :page="data.paginate.page"
                      :index="k"
                    />
                  </td>
                  <td>
                    <CBadge color="warning" v-show="v.status_id == 3">{{
                      v.status_label
                    }}</CBadge>
                    <CBadge color="success" v-show="v.status_id == 2">{{
                      v.status_label
                    }}</CBadge>
                    <CBadge color="primary" v-show="v.status_id == 1">{{
                      v.status_label
                    }}</CBadge>
                  </td>
                  <td>{{ v.cart_ucode }}</td>
                  <td>{{ v.created_at | dateTimeFormat }}</td>
                  <td>{{ v.payment_method }}</td>
                  <td>{{ v.cashier }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </CCardBody>
        <CCardFooter>
          <content-pagination :paginator="data.paginate" @change="changePage" />
        </CCardFooter>
      </CCard>
    </CCol>
    <CCol v-if="!found">
      <CCard>
        <CCardBody>
          Silahkan pilih outlet terlebihdahulu di menu outlet list
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
import ListTable from "../../components/ListTable";
import TableNumber from "../../components/TableNumber";
import ContentPagination from "../../components/ContentPagination2";
import { getOutletCode } from "../../lib/helpers";
import Loader from "../../components/Loader";
export default {
  components: {
    ListTable,
    TableNumber,
    ContentPagination,
    Loader,
  },
  data() {
    return {
      data: {},
      found: true,
      code: "",
      loading: true,
    };
  },
  created() {
    const params = this.$route.params;
    if (params && params.code) {
      var code = params.code;
      console.log(code);
      if (code == "-") {
        code = getOutletCode();
      }
      this.code = code;
      this.get(1);
    }
  },
  methods: {
    get(page) {
      this.loading = true;
      HTTPAUTH.get(
        "/api/admin/outlet/" + this.code + `/transaction?size=10&page=${page}`
      )
        .then((res) => {
          this.data = res.data;
          this.found = true;
          this.loading = false;
        })
        .catch((eres) => {
          this.found = false;
          this.loading = false;
        });
    },
    doBack() {
      this.$router.push({ path: "/outlet" });
    },
    changePage(p) {
      this.get(p);
    },
  },
};
</script>
import { HTTPAUTH } from "../../lib/httplib";
export default {
  components: {},
  data() {
    return {
      data: {},
      found: true,
    };
  },
  created() {
    const params = this.$route.params;
    if (params && params.code) {
      this.get(params.code);
    }
  },
  methods: {
    get(id) {
      HTTPAUTH.get("/api/admin/outlet/" + id + "/transaction")
        .then((res) => {
          this.data = res.data.data;
          this.found = true;
        })
        .catch((eres) => {
          this.found = false;
        });
    },
    doBack() {
      this.$router.push({ path: "/outlet" });
    },
  },
};
</script>